(function () {
  'use strict';

  angular.module('sempraWebapp').factory('totalPurchasedLocalTokensPerDayReportViewModel', totalPurchasedLocalTokensPerDayReportViewModelFactory);

  /** @ngInject */
  function totalPurchasedLocalTokensPerDayReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function totalPurchasedLocalTokensPerDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    totalPurchasedLocalTokensPerDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return totalPurchasedLocalTokensPerDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      that.totalByGroupName = [];

      reportActions.getTotalPurchasedLocalTokensPerDay(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {

        if (successData.length > 0) {
          that.total = successData.map(function (item) {
            return item.count;
          }).reduce(function (total, value) {
            return total + value;
          });
        }

        //successData.unit = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';
        that.chart.data = successData;
        that.unit = $translate.instant('LOCAL_TOKEN');
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();
